import { TPeriod } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';

import { TProduct } from './store/transformShopItem';

/**
 * Способ покупки в рассрочку (duration > 0)
 */
export const isInstallment = (product: TProduct) => !!product.selectedPrice?.duration;

/**
 * Лимиты по единовременной покупке оборудования
 * лимиты устанавливаются на категорию (т.е. в каждой категории можно приобрести не более 5 штук за раз и например декодеров не более 2 штук в рассрочку)
 */
export const limitsByCategories: Record<string, { total: number, installment: number }> = {
    [EShopCategory.Routers]: {
        total: 5,
        installment: 1,
    },
    [EShopCategory.YandexStation]: {
        total: 5,
        installment: 5,
    },
    [EShopCategory.Decoders]: {
        total: 5,
        installment: 2,
    },
    [EShopCategory.PrivateSectorEquipment]: {
        total: 1,
        installment: 1,
    },
};

/**
 * Подсчитывает количество выбранного оборудования
 */
const getTotalCount = (products: TProduct[]): number => {
    return products.reduce((acc: number, curr) => acc + curr.quantity, 0);
};

/**
 * Возвращает продукты в рассрочку
 */
const getProductsInInstallments = (products: TProduct[]) =>
    products?.filter(product => product.quantity > 0 && product.selectedPrice?.duration && product.selectedPrice.duration > 0);

/**
 * Подсчитывает количество оборудования в рассрочку
 */
const getInstalmentCount = (products: TProduct[]): number => {
    const installmentItems = getProductsInInstallments(products);
    return getTotalCount(installmentItems);
};

export interface ILimits {
    total: boolean,
    installment: boolean,
}

/**
 * Достигнут лимит на покупку оборудования (всего и в рассрочку)
 */
export const getLimits = (products: TProduct[], category: string): ILimits => {
    const limit = limitsByCategories[category];
    if (!limit) {
        return {
            total: false,
            installment: false,
        };
    }

    const productsByCategory = products.filter(el => el.category === category);
    const installmentCount = getInstalmentCount(productsByCategory);
    const totalCount = getTotalCount(productsByCategory);

    return {
        total: totalCount >= limit.total,
        installment: installmentCount >= limit.installment,
    };
};

interface IGetTextForOptionsResult {
    text: string,
    isMonthly?: boolean,
}

export const getTextForOptions = (value: TPeriod): IGetTextForOptionsResult => {
    if (value === 0) {
        return {
            text: 'Полная стоимость',
        };
    }

    return {
        text: `Рассрочка на ${value} мес.`,
        isMonthly: true,
    };
};

interface IGetIsDisabledByLimits {
    duration: number,
    productQuantity: number,
    limits: ILimits,
}

export const getIsDisabledByLimits = ({ duration, limits, productQuantity }: IGetIsDisabledByLimits) => {
    const isInstallmentLimit = !!duration && limits.installment && !!productQuantity;
    return limits.total || isInstallmentLimit;
};
